"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoliticalAlliance = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var PoliticalAlliance = (function (_super) {
    __extends(PoliticalAlliance, _super);
    function PoliticalAlliance() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.POLITICAL_ALLIANCE,
            cost: 4,
            tr: { tr: 1 },
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.partyLeaders(2); }),
            metadata: {
                cardNumber: 'X09',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.tr(1);
                }),
                description: 'Requires that you have 2 party leaders. Gain 1 TR.',
            },
        }) || this;
    }
    PoliticalAlliance.prototype.play = function (player) {
        player.increaseTerraformRating();
        return undefined;
    };
    return PoliticalAlliance;
}(Card_1.Card));
exports.PoliticalAlliance = PoliticalAlliance;
